import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 60%;
  padding: 24px;

  box-shadow: 0px 4px 16px -4px rgba(145, 158, 171, 0.12);
  border-radius: 16px;
`;

export const LegendsContainer = styled.div`
  margin-bottom: 32px;

  display: flex;
  justify-content: flex-end;
  align-items: center;

  div + div {
    margin-left: 24px;
  }
`;

export const ChartLegend = styled.div`
  display: flex;
  align-items: center;

  p {
    margin: 0;
    margin-right: 8px;
    color: #6a6a6a;
  }
`;

export const LoadingContainer = styled.div`
  position: absolute;
  top: 0;

  width: calc(100% - 48px);
  height: 100%;

  z-index: 999;

  background: rgba(255, 255, 255, 0.8);

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const NoDataContainer = styled.div`
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  h3 {
    font-size: 18px;
    color: #aaa;
  }
`;
